import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, MapPin, ChevronRight } from 'lucide-react';
const events = [{
  id: 1,
  date: 'JAN 23',
  fullDate: 'Friday, January 23, 2026',
  title: 'AFTER HOURS',
  artist: 'NOMADIQ',
  time: '1AM',
  venue: 'Main Floor',
  image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?q=80&w=1000&auto=format&fit=crop',
  type: 'FRIDAY'
}, {
  id: 2,
  date: 'JAN 24',
  fullDate: 'Saturday, January 24, 2026',
  title: 'AFTER HOURS',
  artist: 'DJ NINO',
  time: '1AM',
  venue: 'Main Floor',
  image: 'https://images.unsplash.com/photo-1571266028243-371695039989?q=80&w=1000&auto=format&fit=crop',
  type: 'SATURDAY'
}, {
  id: 3,
  date: 'JAN 25',
  fullDate: 'Sunday, January 25, 2026',
  title: 'INDUSTRY SUNDAY',
  artist: 'DJ KILOO',
  time: '1AM',
  venue: 'Rooftop',
  image: 'https://images.unsplash.com/photo-1598387993441-a364f854c3e1?q=80&w=1000&auto=format&fit=crop',
  type: 'SUNDAY'
}, {
  id: 4,
  date: 'JAN 29',
  fullDate: 'Thursday, January 29, 2026',
  title: "DRINK DANCE DRAI'S",
  artist: 'DJ MARX',
  time: '10PM',
  venue: 'Lounge',
  image: 'https://images.unsplash.com/photo-1533174072545-e8d4aa97edf9?q=80&w=1000&auto=format&fit=crop',
  type: 'THURSDAY'
}, {
  id: 5,
  date: 'JAN 30',
  fullDate: 'Friday, January 30, 2026',
  title: 'AFTER HOURS',
  artist: 'DJ POUN',
  time: '1AM',
  venue: 'Main Floor',
  image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=1000&auto=format&fit=crop',
  type: 'FRIDAY'
}, {
  id: 6,
  date: 'JAN 31',
  fullDate: 'Saturday, January 31, 2026',
  title: 'AFTER HOURS',
  artist: 'DJ ROMEO',
  time: '1AM',
  venue: 'Main Floor',
  image: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?q=80&w=1000&auto=format&fit=crop',
  type: 'SATURDAY'
}, {
  id: 7,
  date: 'FEB 1',
  fullDate: 'Sunday, February 1, 2026',
  title: 'INDUSTRY SUNDAY',
  artist: 'GUEST DJ',
  time: '1AM',
  venue: 'Rooftop',
  image: 'https://images.unsplash.com/photo-1514525253440-b393452e8d26?q=80&w=1000&auto=format&fit=crop',
  type: 'SUNDAY'
}, {
  id: 8,
  date: 'FEB 5',
  fullDate: 'Thursday, February 5, 2026',
  title: 'LADIES NIGHT',
  artist: 'SPECIAL GUEST',
  time: '10PM',
  venue: 'Lounge',
  image: 'https://images.unsplash.com/photo-1545128485-c400e7702796?q=80&w=1000&auto=format&fit=crop',
  type: 'THURSDAY'
}, {
  id: 9,
  date: 'FEB 6',
  fullDate: 'Friday, February 6, 2026',
  title: 'AFTER HOURS',
  artist: 'RESIDENT DJ',
  time: '1AM',
  venue: 'Main Floor',
  image: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?q=80&w=1000&auto=format&fit=crop',
  type: 'FRIDAY'
}, {
  id: 10,
  date: 'FEB 7',
  fullDate: 'Saturday, February 7, 2026',
  title: 'AFTER HOURS',
  artist: 'RESIDENT DJ',
  time: '1AM',
  venue: 'Main Floor',
  image: 'https://images.unsplash.com/photo-1516280440614-6697288d5d38?q=80&w=1000&auto=format&fit=crop',
  type: 'SATURDAY'
}, {
  id: 11,
  date: 'FEB 8',
  fullDate: 'Sunday, February 8, 2026',
  title: 'BIG GAME',
  artist: 'WATCH PARTY',
  time: '2PM',
  venue: 'Sports Lounge',
  image: 'https://images.unsplash.com/photo-1518609878373-06d740f60d8b?q=80&w=1000&auto=format&fit=crop',
  type: 'SUNDAY'
}];
export function EventsListView() {
  return <div className="space-y-4" data-id="element-224">
      {events.map((event, index) => <motion.div key={event.id} initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      delay: index * 0.05,
      duration: 0.4
    }} className="group bg-[#11161A] border border-white/10 hover:border-[#DDA247] transition-all duration-300 overflow-hidden cursor-pointer" data-id="element-225">
          <div className="flex flex-col md:flex-row" data-id="element-226">
            {/* Image */}
            <div className="relative w-full md:w-64 h-64 md:h-48 overflow-hidden shrink-0" data-id="element-227">
              <img src={event.image} alt={event.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-228" />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#11161A]/50" data-id="element-229" />
            </div>

            {/* Content */}
            <div className="flex-1 p-6 flex flex-col justify-between" data-id="element-230">
              <div data-id="element-231">
                <div className="flex items-start justify-between mb-3" data-id="element-232">
                  <div data-id="element-233">
                    <span className="inline-block bg-[#DDA247] text-[#0B1014] px-3 py-1 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-234">
                      {event.type}
                    </span>
                    <h3 className="text-2xl font-bold text-white uppercase tracking-wide mb-1" data-id="element-235">
                      {event.title}
                    </h3>
                    <p className="text-[#DDA247] text-xl font-bold mb-4" data-id="element-236">
                      {event.artist}
                    </p>
                  </div>
                  <ChevronRight className="text-gray-400 group-hover:text-[#DDA247] transition-colors" data-id="element-237" />
                </div>

                <div className="flex flex-wrap gap-4 text-sm text-gray-400" data-id="element-238">
                  <div className="flex items-center" data-id="element-239">
                    <Calendar className="w-4 h-4 mr-2 text-[#DDA247]" data-id="element-240" />
                    <span data-id="element-241">{event.fullDate}</span>
                  </div>
                  <div className="flex items-center" data-id="element-242">
                    <Clock className="w-4 h-4 mr-2 text-[#DDA247]" data-id="element-243" />
                    <span data-id="element-244">{event.time}</span>
                  </div>
                  <div className="flex items-center" data-id="element-245">
                    <MapPin className="w-4 h-4 mr-2 text-[#DDA247]" data-id="element-246" />
                    <span data-id="element-247">{event.venue}</span>
                  </div>
                </div>
              </div>

              <div className="mt-4 flex items-center justify-between" data-id="element-248">
                <button className="bg-[#DDA247] text-[#0B1014] px-6 py-2 text-sm font-bold uppercase tracking-wider hover:bg-white transition-colors" data-id="element-249">
                  Buy Tickets
                </button>
                <span className="text-gray-500 text-sm" data-id="element-250">View Details →</span>
              </div>
            </div>
          </div>
        </motion.div>)}
    </div>;
}